import { Injectable } from '@angular/core';
import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';
import { BooleanMatcher } from './boolean.config';
import { ContainsMatcher } from './contains.config';
import { DateTimeMatcher } from './date-time.config';
import { EnhancedTextMatcher } from './enhanced-text.config';
import { FullMatchMatcher } from './full-match.config';
import { MultiContainsMatcher } from './multi-contains.config';
import { MultiTextSearchMatcher } from './multi-text-search.config';
import { InPastDayMatcher } from './in-past-day.config';
import { InPastHourMatcher } from './in-past-hour.config';
import { InPastWeekMatcher } from './in-past-week.config';
import { IsMatcher } from './is.config';
import { IsNotMatcher } from './is-not.config';
import { NumberMatcher } from './number.config';
import { OneOfMatcher } from './one-of.config';
import { OuTreePickerMatcher } from './ou-tree-picker.config';
import { SelectFromMatcher } from './select-from.config';
import { StartsWithMatcher } from './starts-with.config';

@Injectable({
  providedIn: 'root',
})
export class MatchersService {
  public static Matchers: { [key: string]: FieldMatcher } = {
    startsWith: StartsWithMatcher,
    fullMatch: FullMatchMatcher,
    selectFrom: SelectFromMatcher,
    boolean: BooleanMatcher,
    inPastHour: InPastHourMatcher,
    inPastDay: InPastDayMatcher,
    inPastWeek: InPastWeekMatcher,
    oneOf: OneOfMatcher,
    contains: ContainsMatcher,
    dateTime: DateTimeMatcher,
    numberMatch: NumberMatcher,
    enhancedText: EnhancedTextMatcher,
    multiContains: MultiContainsMatcher,
    multiTextSearch: MultiTextSearchMatcher,
    is: IsMatcher,
    isNot: IsNotMatcher,
    ouTreePicker: OuTreePickerMatcher,
  };
}